import * as React from 'react';
import withStyles from 'react-jss';
import { useGenericState } from 'src/Library/UseGenericState';
import { StylesProps } from 'src/Library/Types';
import { Button, message, Modal} from 'antd';
import { deleteShipment } from 'src/api/shipmentExecution';
import GetExecutionData from 'src/dto/response/getExecution';
import FailureArrayHandleRfq from 'src/components/common/FailureArrayHandleRfq';

const styles = () => ({
  modalStyle: {
    color: '#111111',
    padding: '30px 20px',
    height: '150px',
    width: '80%',
    overflow: 'auto',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  showBulkDeleteModal: boolean;
  selectedShipments: Record<string, GetExecutionData>;
  onBack: (params: any) => void;
  setShowBulkDeleteModal: (params: boolean) => void;
  resetFilters: () => void;

}

interface StateProps {
  isDeleting?: boolean;
  isErrorModalVisible?: boolean;
  errorArrayData?: any[];
}

const SEBulkDelete = (props: IProps) => {

  const [state, setState] = useGenericState<StateProps>({
    isDeleting: false,
    isErrorModalVisible: false,
    errorArrayData: [],
  });

  const {
    isDeleting,
    isErrorModalVisible,
    errorArrayData,
  } = state;

  const {
    classes,
    showBulkDeleteModal,
    selectedShipments,
    onBack,
    setShowBulkDeleteModal,
    resetFilters,
  } = props;  
  
  const renderModalTitle = () => {
    return (<div>
        <span>
            Confirmation!
        </span>
    </div>)
  }

  const handleErrorModal = () => {
    setState({isErrorModalVisible: !isErrorModalVisible});
  };

  const renderFailureArrayModal = () => {
    if (!isErrorModalVisible) return null;
    return (
      <FailureArrayHandleRfq
        id={'REFERENCE_NUMBER'}
        failureArray={errorArrayData}
        isVisible={isErrorModalVisible}
        onModalClose={() =>{ 
          handleErrorModal();
          onBack({isSuccess: false});
        }}
      />
    );
  };

  const handleDeleteShipment = async () => {
    setState({ isDeleting: true });
    const shipmentIds = Object.keys(selectedShipments);
    const params = {
      shipmentIdList: shipmentIds,
      deletionReason: 'Bulk Delete',
    };
    const response = await deleteShipment(params);
    if (response.isSuccess) {
      if (response.data?.failureArray?.length) {
        const failureArray = response?.data?.failureArray?.map((obj) => ({
          objectId: obj.reference_number,
          reasons: [{ message: obj.error_message }],
        }));
        setState({errorArrayData: failureArray || [] , isErrorModalVisible: true});
      } else {
        message.success('Shipment(s) deleted successfully');
        resetFilters();
        onBack({isSuccess: true});
      }
      setState({ isDeleting: false });
    } else {
      message.error(response.errorMessage);
      setState({ isDeleting: false });
      onBack({});
    }
  };

  const renderFooter = () => {
    return (
      <div style={{display:'flex', alignItems:'flex-start'}}>
        <Button 
        onClick={handleDeleteShipment}
        style={{background: '#016FC3', border: 'none', color: '#FFFFFF'}}
        loading={isDeleting}
        >
          Yes! Do it
        </Button>
        <Button onClick={onBack} style={{ marginRight: '8', border: 'none', color: '#000000'}}>
          No! Cancel it
        </Button>
      </div>
    );
  };

  return (
    <Modal
      closable={true}
      title={renderModalTitle()}
      bodyStyle={{
        color: '#111111',
        padding: '30px 20px',
        margin: '0',
        height: '150px',
        overflow: 'auto',
      }}
      onCancel={onBack}
      visible={showBulkDeleteModal}
      footer={renderFooter()}
    >
      <div style={{display: 'flex', flexDirection: 'column', fontWeight: 500, fontSize: '14px'}}>
        <span>Are you sure you want to delete the selected shipment(s)</span>
        <span>This Process cannot be undone</span>
      </div>
      {renderFailureArrayModal()}
    </Modal>
  );
};

export default withStyles(styles)(SEBulkDelete);

